export default "__VITE_ASSET__CoD9aDt2__"